export default "__VITE_ASSET__CSLdJck$__"